import { EnvHostInfo } from '@typesApp/Config'
import apiHostDev from './apihost-dev.json'
import apiHostTest from './apihost-test.json'
import apiHostStage from './apihost-stage.json'
import apiHostProd from './apihost-prod.json'

export const apiHostConfig = {
  DEV: {
    commerceEnv: 'dev',
    ...apiHostDev,
  },
  TEST: {
    commerceEnv: 'int',
    ...apiHostTest,
  },
  STAGE: {
    commerceEnv: 'uat',
    ...apiHostStage,
  },
  PROD: {
    commerceEnv: 'prod',
    ...apiHostProd,
  },
} as Record<'DEV' | 'TEST' | 'STAGE' | 'PROD', EnvHostInfo>
